var $f8ec7c0a220ba7e4$exports = {};
$f8ec7c0a220ba7e4$exports = {
    "collapse": `R\xe9duire`,
    "columnResizer": `Redimensionnement de colonne`,
    "drag": `Faire glisser`,
    "expand": `D\xe9velopper`,
    "loading": `Chargement...`,
    "loadingMore": `Chargement suppl\xe9mentaire...`,
    "resizeColumn": `Redimensionner la colonne`,
    "sortAscending": `Trier par ordre croissant`,
    "sortDescending": `Trier par ordre d\xe9croissant`
};


export {$f8ec7c0a220ba7e4$exports as default};
//# sourceMappingURL=fr-FR.mjs.map
